<!-- Vista compacta de una sola pantalla sin scroll -->
<div class="container-fluid mt-2 px-3" style="font-size: 0.88rem;">
  
  <!-- Encabezado de la página -->
  <div class="d-flex justify-content-between align-items-center mb-2 border-bottom pb-1">
    <h2 class="h5 m-0 fw-bold text-dark">Crear Unidad</h2>
    <span class="badge bg-success">Nueva Alta</span>
  </div>

  <form [formGroup]="unidadForm" (ngSubmit)="addUnidad()">

  <!-- ========================================================================= -->
  <!-- SECCIÓN 1: PROPIETARIO VEHICULAR (ENLACE DIRECTO DE MÁXIMA CERTEZA)      -->
  <!-- ========================================================================= -->
  <div class="card bg-light mb-2 border-0 shadow-sm">
    <div class="card-body p-2">
      
      <!-- Mantenemos el grupo para el select -->
      <div class="row g-2" formGroupName="propietario">
        
        <!-- Columna 1: Selector del Cliente -->
        <div class="col-md-8">
          <div class="form-floating">
            <select class="form-select form-select-sm" id="selectClienteName" formControlName="an8"
                    [ngClass]="{'is-invalid': unidadForm.get('propietario.an8')?.touched && unidadForm.get('propietario.an8')?.invalid}">
              <option [ngValue]="null">-- Busque o seleccione nombre --</option>
              <option *ngFor="let cliente of clientes" [ngValue]="cliente.an8">
                {{ cliente.name }} (AN8: {{ cliente.an8 }})
              </option>
            </select>
            <label for="selectClienteName" class="fw-bold text-primary">Cliente Propietario *</label>
            <div class="invalid-feedback">Debe asociar obligatoriamente un cliente al vehículo.</div>
          </div>
        </div>

        <!-- Columna 2: Cuadro de texto del Código Corporativo (AN8) -->
        <div class="col-md-4">
          <div class="form-floating">
            <!-- 🌟 SOLUCIÓN DEFINITIVA: 
                1. Removemos formControlName de este campo para evitar conflictos de renderizado.
                2. Forzamos el valor visual leyendo directamente el estado del FormBuilder con [value].
                3. Usamos [disabled]="true" para que Bootstrap lo pinte como campo de lectura seguro. -->
            <input type="text" 
                  class="form-control bg-light text-secondary" 
                  id="editAn8Input" 
                  [value]="unidadForm.get('propietario.an8')?.value ?? ''" 
                  [disabled]="true">
            <label for="editAn8Input">Código Corporativo (AN8)</label>
          </div>
        </div>

      </div>

    </div>
  </div>

    <!-- ========================================================================= -->
    <!-- SECCIÓN 2: DATOS GENERALES Y TÉCNICOS DEL VEHÍCULO                        -->
    <!-- ========================================================================= -->
    <div class="card mb-2 border-0 shadow-sm">
      <div class="card-body p-2">
        
        <!-- 🌟 FILA 1: IDENTIDAD ESENCIAL (4 COLUMNAS EXACTAS) -->
        <div class="row g-2 mb-2">
          <div class="col-md-3">
            <div class="form-floating">
              <select class="form-select" id="marca" formControlName="marca" (change)="onMarcaSeleccionada($event)"
                      [ngClass]="{'is-invalid': unidadForm.get('marca')?.touched && unidadForm.get('marca')?.invalid}">
                <option value="">-- Seleccione Marca --</option>
                <option *ngFor="let m of marcas" [value]="m.keyRef">{{ m.description }}</option>
              </select>
              <label for="marca" class="fw-bold">Marca *</label>
              <div class="invalid-feedback">La marca es requerida.</div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating">
              <select class="form-select" id="submarca" formControlName="submarca"
                      [ngClass]="{'is-invalid': unidadForm.get('submarca')?.touched && unidadForm.get('submarca')?.invalid}">
                <option value="">-- Elige Submarca --</option>
                <option *ngFor="let sm of submarcas" [value]="sm.keyRef">
                  {{ sm.description }} <span *ngIf="sm.strValue2">({{ sm.strValue2 }})</span>
                </option>
              </select>
              <label for="submarca" class="fw-bold">Submarca *</label>
              <div class="invalid-feedback">Debe elegir una submarca válida.</div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating">
              <select class="form-select" id="modelo" formControlName="modelo"
                      [ngClass]="{'is-invalid': unidadForm.get('modelo')?.touched && unidadForm.get('modelo')?.invalid}">
                <option value="">-- Seleccione Año Modelo --</option>
                <option *ngFor="let anio of listaAnios" [value]="anio">{{ anio }}</option>
              </select>
              <label for="modelo" class="fw-bold">Modelo (Año Versión) *</label>
              <div class="invalid-feedback">El modelo es requerido.</div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating">
              <select class="form-select" id="aniofabricacion" formControlName="aniofabricacion"
                      [ngClass]="{'is-invalid': unidadForm.get('aniofabricacion')?.touched && unidadForm.get('aniofabricacion')?.invalid}">
                <option value="">-- Seleccione Año Fab. --</option>
                <option *ngFor="let anio of listaAnios" [value]="anio">{{ anio }}</option>
              </select>
              <label for="aniofabricacion" class="fw-bold">Año de Fabricación *</label>
              <div class="invalid-feedback">El año de fabricación es requerido.</div>
            </div>
          </div>
        </div>

		    <!-- 🌟 FILA 2: CONTROL Y ESTÉTICA ACTUALIZADA CON ALERTAS -->
        <div class="row g-2 mb-2">
          <div class="col-md-2">
            <div class="form-floating">
              <input type="text" class="form-control text-uppercase" id="placas" formControlName="placas"                     
                     appUppercase                                            
                     [ngClass]="{'is-invalid': unidadForm.get('placas')?.touched && unidadForm.get('placas')?.invalid}">
              <label for="placas">Placas *</label>
              <div class="invalid-feedback">Las placas son requeridas.</div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-floating">
              <!-- 🌟 AGREGADO: [ngClass] e invalid-feedback -->
              <input type="text" class="form-control text-uppercase" id="tcirculacion" formControlName="tcirculacion"                     
                     appUppercase                                           
                     [ngClass]="{'is-invalid': unidadForm.get('tcirculacion')?.touched && unidadForm.get('tcirculacion')?.invalid}">
              <label for="tcirculacion">Tarjeta Circulación *</label>
              <div class="invalid-feedback">La tarjeta de circulación es requerida.</div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating">
              <!-- 🌟 AGREGADO: [ngClass] e invalid-feedback -->
              <select class="form-select" id="tipocombustible" formControlName="tipocombustible"
                      [ngClass]="{'is-invalid': unidadForm.get('tipocombustible')?.touched && unidadForm.get('tipocombustible')?.invalid}">
                <option value="">-- Seleccione combustible --</option>
                <option *ngFor="let combustible of tiposCombustible" [value]="combustible">{{ combustible }}</option>
              </select>
              <label for="tipocombustible">Tipo de Combustible *</label>
              <div class="invalid-feedback">Seleccione el tipo de combustible.</div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating">
              <!-- 🌟 AGREGADO: [ngClass] e invalid-feedback -->
              <select class="form-select" id="tiposervicio" formControlName="tiposervicio"
                      [ngClass]="{'is-invalid': unidadForm.get('tiposervicio')?.touched && unidadForm.get('tiposervicio')?.invalid}">
                <option value="">-- Seleccione servicio --</option>
                <option *ngFor="let servicio of tiposServicio" [value]="servicio">{{ servicio }}</option>
              </select>
              <label for="tiposervicio">Tipo de Servicio *</label>
              <div class="invalid-feedback">Seleccione el tipo de servicio.</div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-floating">
              <!-- 🌟 AGREGADO: [ngClass] e invalid-feedback -->
              <select class="form-select" id="color" formControlName="color"
                      [ngClass]="{'is-invalid': unidadForm.get('color')?.touched && unidadForm.get('color')?.invalid}">
                <option value="">-- Seleccione color --</option>
                <option *ngFor="let col of coloresUnidad" [value]="col">{{ col }}</option>
              </select>
              <label for="color">Color *</label>
              <div class="invalid-feedback">El color es requerido.</div>
            </div>
          </div>
        </div>

        <!-- 🌟 FILA 3: IDENTIFICADORES LARGOS ACTUALIZADA CON ALERTAS -->
        <div class="row g-2">
          <div class="col-md-3">
            <div class="form-floating">
              <!-- 🌟 AGREGADO: [ngClass] e invalid-feedback -->
              <input type="text" class="form-control text-uppercase" id="numerovin" formControlName="numerovin"                     
                     appUppercase                
                     [ngClass]="{'is-invalid': unidadForm.get('numerovin')?.touched && unidadForm.get('numerovin')?.invalid}">
              <label for="numerovin">Número VIN (Chasis) *</label>
              <div class="invalid-feedback">El número VIN es obligatorio.</div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating">
              <!-- 🌟 AGREGADO: [ngClass] e invalid-feedback -->
              <input type="text" class="form-control text-uppercase" id="numeromotor" formControlName="numeromotor"                     
                     appUppercase                                     
                     [ngClass]="{'is-invalid': unidadForm.get('numeromotor')?.touched && unidadForm.get('numeromotor')?.invalid}">
              <label for="numeromotor">Número de Motor *</label>
              <div class="invalid-feedback">El número de motor es obligatorio.</div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-floating">
              <select class="form-select" id="status" formControlName="status">
                <option *ngFor="let est of estatusUnidad" [value]="est">{{ est }}</option>
              </select>
              <label for="status">Estatus</label>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-floating">
              <input type="datetime-local" class="form-control bg-light" id="fechaalta" formControlName="fechaalta" readonly>
              <label for="fechaalta">Fecha Entrada (Sistema)</label>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- SECCIÓN DE ACCIONES (Botón clásico, elegante y alineado a la derecha) -->
    <div class="d-flex justify-content-end gap-2 border-top pt-2 mt-2">
	    <!-- 🚀 ACTIVACIÓN DE SALIDA SEGURA EN ALTA DE VEHÍCULOS -->
      <!-- Cambiamos a la etiqueta <a> con routerLink para regresar de golpe al listado general '/unidad' -->
      <a routerLink="/unidad" class="btn btn-sm btn-outline-secondary px-4 d-inline-flex align-items-center">
        Cancelar
      </a>
      <button type="submit" class="btn btn-sm text-white px-4 shadow-sm" 
              [style.opacity]="unidadForm.invalid ? '0.5' : '1'" 
              style="background-color: #198754; font-weight: 500;">
        Guardar Unidad
      </button>
    </div>

  </form>
</div>

<!-- 🌟 CONTENEDOR FLOTANTE DE TOASTS (Añadir al final de la pantalla de unidades) -->
<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
  <div *ngFor="let toast of toastService.toasts" 
       class="toast show shadow border-0 mb-2" 
       [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
       role="alert" aria-live="assertive" aria-atomic="true">
    
    <!-- Encabezado de la Alerta -->
    <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
      <strong class="me-auto d-flex align-items-center gap-2">
        <span *ngIf="toast.type === 'danger'">⚠️</span>
        <span *ngIf="toast.type === 'success'">✅</span>
        {{ toast.title }}
      </strong>
      <button type="button" class="btn-close" (click)="toastService.remove(toast)" aria-label="Close"></button>
    </div>
    
    <!-- Cuerpo de la Alerta -->
    <div class="toast-body pt-0" style="font-size: 0.85rem;">
      {{ toast.text }}
    </div>
  </div>
</div>